@import "../../../../shared/scss";

@mixin skeleton() {
  &.skeleton {
    pointer-events: none;
    user-select: none;
    display: block;
    box-sizing: content-box;
    background: $pds-theme-light-contrast-low;

    phn-p-heading {
      visibility: hidden;

      &:empty::after,
      & *:empty::after {
        content: "\00a0";
      }
    }
  }
}

:host {
  display: flex;
  flex-direction: column;
  align-items: center;

  phn-p-heading {
    @include pds-heading-large;
  }

  div.text-limit {
    @include pds-media-query-min("base") {
      inline-size: 180px;
    }

    @include pds-media-query-min("xs") {
      inline-size: 100%;
    }
  }
}
